var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-small font-weight-bold text-center"},[_vm._v(" "+_vm._s(_vm.$t(_vm.description))+" ")]),_c('SelectKnowledgeParameters',{staticClass:"section",attrs:{"init-filters":_vm.initFilters},on:{"update-product-filters":_vm.sendUpdateProductFiltersEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }